import { Component } from '@angular/core';

import { saveAs } from 'file-saver';

import * as XLSX from 'xlsx';
import { Store, select } from '@ngrx/store';
import { SharedService } from '../../../shared/shared.service';
import { Router } from '@angular/router';
import { getAllWalletHistorylist } from '../../../store/Wallet/wallet.action';
import { getAllWalletHistoryResponse } from '../../../store/Wallet/wallet-selector';
import { getBillHistoryExport } from '../../../store/customer/consumer.action';
import { Subscription } from 'rxjs';
import { getBillHistoryExportResponse } from '../../../store/customer/consumer-selector';
import { SweetAlertIcon } from '../../../shared/constants/enum';
import { NotificationService } from '../../../shared/notification.service';
import { formatDate } from '@angular/common';
import { WalletService } from '../../../core/services/wallet.services';
import { LoaderService } from '../../../core/services/loader.service';
@Component({
  selector: 'app-rp-wallet-history',
  templateUrl: './rp-wallet-history.component.html',
  styleUrl: './rp-wallet-history.component.scss',
  standalone: false,
})
export class RpWalletHistoryComponent {
  currentUserData: any;
  walletId: any;
  totalwallethistoryCount: number = 0;
  getAllWalletHistoryList: any;
  billingType: any;

  breadCrumbItems: Array<{}> | undefined;
  private exportSubscription: Subscription = new Subscription();
  constructor(
    private sharedService: SharedService,
    private store: Store,
    private notificationService: NotificationService,
    private walletService: WalletService,
    private loaderService: LoaderService
  ) {
    const currentUserString = localStorage.getItem('currentUser');
    this.currentUserData = JSON.parse(currentUserString ?? '');
    this.notificationService.emitNotificationUpdate();
    if (this.currentUserData.currentUserRoleDetails !== null) {
      this.walletId =
        this.currentUserData?.currentUserRoleDetails?.consumerWalletId;
      console.log('Wallet ID:', this.walletId);
      this.sharedService.setwalletHistoryById(this.walletId);
    }
    console.log(this.currentUserData);
    this.billingType = this.currentUserData?.project?.billingType;
    this.breadCrumbItems = [{ label: 'Wallet History' }];
  }
  public onCountChange(count: number): void {
    this.totalwallethistoryCount = count;
    console.log('Count received from child:', this.totalwallethistoryCount);
  }
  ngOnDestroy() {
    this.exportSubscription.unsubscribe(); // Or set it to [] if you prefer an empty array
  }
  walletsExportAll() {
    this.loaderService.setLoading(true);
    // this.getAllWalletHistory();
    this.walletService
      .getWalletsHistory(
        1, // pageIndex
        undefined, // pageSize
        '', // searchTerm
        this.walletId, // walletId (must be 4th)
        '', // filter
        '' // orderBy
      )
      .subscribe({
        next: (res) => {
          if (res) {
            console.log(res);
            if (res.data.items.length > 0) {
              this.totalwallethistoryCount = res.data.totalCount;
              this.getAllWalletHistoryList = [...res.data.items];
              this.billstypeExport(this.getAllWalletHistoryList);
              this.loaderService.setLoading(false);
            } else {
              this.loaderService.setLoading(false);
              this.sharedService.showMessageDialog(
                'No data to display',
                '',
                SweetAlertIcon.ERROR
              );
            }
          }
        },
        error: (err) => {
          this.loaderService.setLoading(false);
        },
      });
  }

  getAllWalletHistory(): void {
    this.store.dispatch(
      getAllWalletHistorylist({
        pageIndex: 1,
        pageSize: undefined,
        searchTerm: '',
        filter: '',
        orderBy: '',
        walletId: this.walletId,
      })
    );

    //getWalletsHistory
  }

  billstypeExport(response: any) {
    if (this.billingType == 'Postpaid') {
      this.billHistoryExport(response);
    } else {
      this.export(response);
    }
  }
  export(data: any): void {
    const workbook = XLSX.utils.book_new();
    const masterDetailData: any[] = [];
    //console.log(data)
    data.forEach((item: any) => {
      masterDetailData.push({
        // Date: item.paidDate,
        Date: formatDate(item.paidDate, 'dd MMM yyyy', 'en-US'),
        'Amount Deducted': item.totalAmountDeducted,
        'Opening Balance': item.openingBalance,
        'Closeing Balance': item.closingBalance,
        // 'Residential Unit': '',
        utility: '',
        'Device Sr No': '',
        'Mac Address': '',
        consumption: '',
        'Consumption Unit EB': '',
        'Consumption Unit DG': '',
        'Unit Rate': '',
        //'Unit Rate EB': '',
        // 'Unit Rate DG': '',
        'Available Balance': '',
        'Initial Reading': '',
        'Final Reading': '',
        'Initial MeterReading EB': '',
        'Initial Meter Reading DG': '',
        'Final MeterReading EB': '',
        'Final Meter Reading DG': '',
        'Service Name': '',
        'Gst Amount': '',
        'Gst percentage': '',
      });

      item.walletDtls.forEach((detail: any) => {
        masterDetailData.push({
          Date: '',
          'Amount Deducted': detail.amountDeducted,
          'Opening Balance': '',
          'Closeing Balance': '',
          // 'Residential Unit': detail.residentialUnit,
          utility: detail.utility,
          'Device Sr No': detail.meterNo,
          'Mac Address': detail.macAddress,
          consumption: detail.consumptionUnits,
          'Consumption Unit EB': detail.consumptionUnitsEB,
          'Consumption Unit DG': detail.consumptionUnitsDG,
          'Available Balance': detail.availableBalance,
          'Unit Rate': detail.unitRate,
          //'Unit Rate EB': detail.unitRateEB,
          // 'Unit Rate DG': detail.unitRateDG,
          'Initial Reading': detail.initialMeterReading,
          'Final Reading': detail.finalMeterReading,
          'Initial MeterReading EB': detail.initialMeterReadingEB,
          'Initial Meter Reading DG': detail.initialMeterReadingDG,
          'Final MeterReading EB': detail.finalMeterReadingEB,
          'Final Meter Reading DG': detail.finalMeterReadingDG,
          'Service Name': detail.serviceName,
          'Gst Amount': detail.gstAmount,
          'Gst percentage': detail.gstPer,
        });
      });
    });

    const worksheet = XLSX.utils.json_to_sheet(masterDetailData, {});

    const range = XLSX.utils.decode_range(worksheet['!ref'] as string);
    for (let col = range.s.c; col <= range.e.c; col++) {
      const cell = worksheet[XLSX.utils.encode_cell({ r: 0, c: col })];
      if (cell) {
        cell.s = { font: { bold: true } };
      }
    }

    XLSX.utils.book_append_sheet(workbook, worksheet, 'WalletHistory');
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    saveAs(
      new Blob([wbout], { type: 'application/octet-stream' }),
      'Wallet History.xlsx'
    );
  }

  // bill History export Excl:
  billHistoryExport(data: any): void {
    const workbook = XLSX.utils.book_new();
    const masterDetailData: any[] = [];
    data.forEach((item: any) => {
      masterDetailData.push({
        Date: formatDate(item.paidDate, 'dd MMM yyyy', 'en-US'),
        'Amount Deducted': item.totalAmountDeducted,
        'Opening Balance': item.openingBalance,
        'Closeing Balance': item.closingBalance,
        'Bill No': '',
        'Residential Unit': '',
        'Bill Date': '',
        'Payment Date': '',
        utility: '',
        'Bill Type': '',
        Reason: '',
        'Device Sr No': '',
        'Mac Address': '',
        'Bill Amount': '',
        'Mode Of Payment': '',
        'Payment Status': '',
      });

      item.walletDtls.forEach((detail: any) => {
        masterDetailData.push({
          Date: '',
          'Amount Deducted': '',
          'Opening Balance': '',
          'Closeing Balance': '',
          'Bill No': detail.billNo,
          'Residential Unit': detail.residentialUnit,
          'Bill Date': formatDate(detail.billDate, 'dd MMM yyyy', 'en-US'),
          'Payment Date': formatDate(
            detail.paymentDate,
            'dd MMM yyyy',
            'en-US'
          ),
          utility: detail.utility,
          'Bill Type': detail.billType,
          Reason: detail.reason,
          'Device Sr No': detail.meterNo,
          'Mac Address': detail.macAddress,
          'Bill Amount': detail.totalAmount,
          'Mode Of Payment': detail.paymentMode,
          'Payment Status': detail.paymentStatus,
        });
      });
    });
    /*   data.forEach((item: any) => {
      masterDetailData.push({
        'Date': formatDate(item.paidDate, 'dd MMM yyyy', 'en-US'),
        'Amount Deducted': item.totalAmountDeducted,
        'Residential Unit': '',
        'Bill No': '',
        utility: '',
        'Meter No': '',
        'Bill Date': '',
        'Bill Amount': '',
        'payment Status': '',
        'Mode Of Payment': '',
      });

      item.walletDtls.forEach((detail: any) => {
        masterDetailData.push({
          'Date': '',
          'Amount Deducted': '',
          'Residential Unit': detail.residentialUnit,
          'Bill No': detail.billNo,
          utility: detail.utility,
          'Meter No': detail.meterNo,
          'Bill Date': formatDate(detail.billDate, 'dd MMM yyyy', 'en-US'),
          'Bill Amount': detail.amount,
          'Payment Status': detail.paymentStatus,
          'Mode Of Payment': detail.modeOfPayment,
        });
      });
    }); */

    const worksheet = XLSX.utils.json_to_sheet(masterDetailData, {});
    console.log(masterDetailData);
    const range = XLSX.utils.decode_range(worksheet['!ref'] as string);
    for (let col = range.s.c; col <= range.e.c; col++) {
      const cell = worksheet[XLSX.utils.encode_cell({ r: 0, c: col })];
      if (cell) {
        cell.s = { font: { bold: true } };
      }
    }

    XLSX.utils.book_append_sheet(workbook, worksheet, 'WalletHistory');
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    saveAs(
      new Blob([wbout], { type: 'application/octet-stream' }),
      'Wallet History.xlsx'
    );
  }
}
